import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// import { ReactComponent as EditIcon } from '../../../assets/icons/edit.svg';
// import { ReactComponent as PlusIcon } from '../../../assets/icons/plus.svg';
import { useAppSelector } from '../../../../redux/hooks';
import SidePaneModel from '../../../../shared-components/table-side-panel/SidePaneModel';
import StationSidePanel from '../../../../shared-components/table-side-panel/StationSidePanel';
import TabsContainer from '../../../../shared-components/tabs-container/TabsContainer';
import AddStation from '../../station-management/components/AddStation';
import StationDevicesLane from '../station-dashboard/StationDevicesLane';

import { StationDetailsLeft, StationDetailsRight } from './station-details/StationDetails';
import StationManagementBottomContainer from './station-details/StationManagementBottomContainer';

/**
 * Station Dashboard
 * @returns {any} The rendered component
 */
function StationDashboard() {
  const { t } = useTranslation('sidePanel');
  const [openTab, setOpenTab] = useState(0);
  const [editStationOpen, setEditStationOpen] = useState(false);
  const [addStationOpen, setAddStationOpen] = useState(false);
  const { selectedChargingPoint } = useAppSelector((state) => state.stationManagement);

  const containerTabs = [
    {
      label: t('lane', 'Lane'),
      key: 'lane',
      isActive: openTab === 0,
    },
    {
      label: t('media', 'Images'),
      key: 'media',
      isActive: openTab === 1,
    },
    {
      label: t('amenities', 'Amenities'),
      key: 'amenities',
      isActive: openTab === 2,
    },
  ];

  /**
   * Function to switch tab
   * @param {string} key - The selected tab key
   */
  const handleSwitchTab = (key: string) => {
    if (key === 'lane') {
      setOpenTab(0);
    } else if (key === 'media') {
      setOpenTab(1);
    } else if (key === 'amenities') {
      setOpenTab(2);
    }
  };

  return (
    <div className="station-dashboard-container">
      <div className="station-devices">
        <div className="left">
          <StationDetailsLeft />
        </div>
        <div className="right">
          <TabsContainer containerTabs={containerTabs} handleSwitchTab={handleSwitchTab} />

          <div className="tab-content-container">
            {openTab === 0 && <StationDevicesLane />}
            {openTab === 1 && <StationDetailsRight showTabs={false} defaultTab="media" />}
            {openTab === 2 && <StationDetailsRight showTabs={false} defaultTab="amenities" />}
          </div>
        </div>
      </div>
      <StationManagementBottomContainer />
      <SidePaneModel
        open={addStationOpen}
        closePanel={() => setAddStationOpen(false)}
        content={
          <AddStation
            onClose={() => setAddStationOpen(false)}
            onSuccess={() => {
              setAddStationOpen(false);
              // Handle refresh if necessary
            }}
          />
        }
        position="right"
        title="addStation"
      />
      <SidePaneModel
        open={editStationOpen}
        closePanel={() => setEditStationOpen(false)}
        content={
          <StationSidePanel
            fetchIdFrom="props"
            id={selectedChargingPoint?.id as string}
            initialIsEditMode
            onEditModeChange={(isEditMode) => {
              if (!isEditMode) {
                setEditStationOpen(false);
              }
            }}
            onClose={() => setEditStationOpen(false)}
            onDeleteStation={() => {}}
            onSuccess={() => window.location.reload()}
          />
        }
        position="right"
        hideHeader
      />
    </div>
  );
}

export default StationDashboard;
